export enum EPhysicalType {
  VIBRO_ACCELERATION = 'VIBRO_ACCELERATION',
  VIBRO_VELOCITY = 'VIBRO_VELOCITY',
  VIBRO_DISPLACEMENT = 'VIBRO_DISPLACEMENT',
  VOLTAGE = 'VOLTAGE',
  AMPERAGE = 'AMPERAGE',
  PHASE = 'PHASE',
  RPM = 'RPM',
  DRPM = 'DRPM',
  TEMPERATURE = 'TEMPERATURE',
  PRESSURE = 'PRESSURE', // Давление
  FLOW_RATE = 'FLOW_RATE' // Расход
}
